import { api, ApiTags } from '../../api';
import type { GetUserByPublicIdRequest, GetUserByPublicIdResponse } from './types';

/**
 * API сервис для работы с пользователями
 */
const userApi = api.injectEndpoints({
    endpoints: build => ({
        /**
         * Получает данные пользователя по publicId
         */
        getUserByPublicId: build.query<GetUserByPublicIdResponse, GetUserByPublicIdRequest>({
            query: ({ publicId }) => `/users/${publicId}`,
            providesTags: (result, error, { publicId }) => [{ type: ApiTags.Users, id: publicId }],
        }),
    }),
});

export const { useGetUserByPublicIdQuery } = userApi;
export * from './types';
